const messages = {
  en: {
    message: {
      title: "HUMANITAS SECURE TELEMEDICINE SERVICE",
      accessInstructions1:
        "Please access the service by entering your mobile phone number " +
        "and accepting Terms and Conditions.",
      accessInstructions2:
        "You will receive a numeric code to be entered on the next page.",
      mandatoryField: "* mandatory field",
      insertPhoneNumber: "Please enter your mobile phone number",
      phonePrefix: "Country code:",
      phoneNumber: "Mobile phone number",
      iHaveRead: "Please read the information on your ",
      termsAndConditions: "personal data processing.",
      afterTermsAndConditions:
        "I consent to the processing of my personal data for the delivery of medical" +
        " report through the platform.",
      confirm: "confirm",
      welcome: "Welcome to Humanitas Secure Telemedicine System",
      pinAccess: "Access with PIN",
      checkReceivedPin: "Check your PIN received on number ",
      pin: "PIN",
      enter: "ENTER",
      patientFiles:
        "Click on the communication you are interested in to see its content and reply and send documents",
      sentOn: "Sent on",
      viewOrDownloadFile: "View or download the file",
      exitPatient: "EXIT",
      replyToCustomerService: "Reply to Humanitas Customer Service",
      uploadOneOrMore:
        "Clicking on 'Confirm' you'll be logged out and brought back to the home page",
      disconnetti: "Exit",
      goBack: "Go back",
      disconMessage: "Click 'Exit' to disconnect and go to homepage",
      cancel: "Cancel",
      exit: "Exit",
      allMandatory: "All fields are mandatory",
      subject: "Subject",
      inserisciMess: "Write your message here",
      send: "Send",
      caricaFile: "Upload one or more files*",
      fileLimit: "only jpeg, png, jpg, pdf and docx, max 25MB",
      sentFiles: "Uploaded Files",
      invalidPrefix: "Invalid prefix",
      invalidPrfMsg: "Enter the prefix in correct format",
      invalidPhNum: "Please enter a valid telephone number",
      invPhNumMsg: "Provided number does not result registered",
      complCampo: "Fill-in the field to continue",
      insValPhNum: "Please enter a valid telephone number",
      insValPhNmMsg: "Enter the number in correct format",
      wrongPin: "WrongPIN",
      wrongPinMsg1: "Remaining attempts: ",
      wrongPinMsg2: "",
      troppeRich: "Too many requests",
      troppeRichMsg:
        "A high number of login attempts were requested by this number. Please wait a few minutes.",
      smsProblem: "Problem sending sms",
      smsProblemMsg:
        "There was a problem with sending SMS with a pin code. Please try again later",
      loading: "Loading...",
      deleteFile: "Delete file",
      viewFile: "View file",
      downloadFile: "Download file",
      close: "Close",
      choosePatient: "Choose the patient",
      choosePatMsg1: "This number was recorded for several patients.",
      choosePatMsg2: "Click on the patient's name to continue.",
      sendAnother: "Send another file",
      nessunFile: "No files",
      inviato: "sent",
      ricevuto: "received",
      sendMailError:
        "Sorry, an error occurred while sending the email, please try again",
      mailFieldsErr: "Subject and message of the email cannot be empty.",
      fileDimErrTit: "Files exceed maximum size",
      fileDimErrMsg: "The set of files cannot exceed 25MB",
      phoneErrTit: "Please enter a valid phone number",
      phoneErrMsg: "The entered format is invalid",
      clickOn: "Click on",
      toSeeFile: "to see the selected file",
      toDownloadFile: "to download the selected file",
      toReply: "to reply and send files",
      sendLabel: "Send",
      downloadLabel: "Download",
      viewLabel: "View"
    }
  },
  it: {
    message: {
      title: "COMUNICAZIONE SICURA",
      accessInstructions1:
        "Per accedere al servizio inserire il recapito telefonico di" +
        "cellulare e prendere visione del trattamento dei dati personali.",
      accessInstructions2:
        "Riceverai un sms con un codice numerico da inserire nella" +
        "schermata successiva.",
      mandatoryField: "* campo obbligatorio",
      insertPhoneNumber: "Inserisci il tuo numero di cellulare",
      phonePrefix: "Prefisso",
      phoneNumber: "Numero di telefono cellulare",
      iHaveRead: " Leggi l'informativa sul ",
      termsAndConditions: "trattamento dei dati personali.",
      afterTermsAndConditions:
        "Acconsento al trattamento dei miei dati personali per la consegna dei referti " +
        "tramite la Piattaforma",
      confirm: "conferma",
      welcome: "Benvenuti nel sistema Comunicazione Sicura di Humanitas.",
      pinAccess: "Accedi con il PIN",
      checkReceivedPin: "Controlla il PIN ricevuto al numero ",
      pin: "PIN",
      enter: "ACCEDI",
      patientFiles:
        "Clicca sulla comunicazione che ti interessa per visualizzare il " +
        "contenuto e per rispondere e inviare documenti.",
      sentOn: "Inviato il",
      viewOrDownloadFile: "Visualizza o scarica il file",
      exitPatient: "ESCI",
      replyToCustomerService: "Risposta al Servizio Clienti Humanitas",
      uploadOneOrMore: "Caricare uno o più file per poter proseguire",
      disconnetti: "Disconnetti",
      goBack: "Torna indietro",
      disconMessage:
        "Cliccando 'Conferma' verrai disconnesso e riportato alla pagina iniziale",
      cancel: "ANNULLA",
      exit: "CONFERMA",
      allMandatory: "Tutti i campi sono obbligatori",
      subject: "Oggetto della mail",
      inserisciMess: "Inserisci qui il messaggio da inviare",
      send: "INVIA",
      caricaFile: "Carica qui uno o più file*",
      fileLimit: "solo jpeg, png, jpg, pdf e docx, max 25MB",
      sentFiles: "File Caricati",
      invalidPrefix: "Prefisso non valido",
      invalidPrfMsg: "Inserire un prefisso in formato corretto",
      invalidPhNum: "Prego inserire un numero di telefono valido",
      invPhNumMsg: "Il numero inserito non è tra quelli registrati",
      complCampo: "Completare il campo per poter proseguire",
      insValPhNum: "Prego inserire un numero di telefono valido",
      insValPhNmMsg: "Il formato inserito non è valido",
      wrongPin: "Il pin inserito non è corretto",
      wrongPinMsg1: "Tentativi rimamenti: ",
      wrongPinMsg2: "",
      troppeRich: "Troppe richieste",
      troppeRichMsg:
        "Un alto numero di tentativi di login è stato richiesto da questo numero. Per favore, attendere qualche minuto.",
      smsProblem: "Problema invio sms",
      smsProblemMsg:
        "Si è verificato un problema con l'invio del sms con il pin. Riprova più tardi.",
      loading: "Caricamento...",
      deleteFile: "Cancella file",
      viewFile: "Visualizza file",
      downloadFile: "Download file",
      close: "Chiudi",
      choosePatient: "Scegli paziente",
      choosePatMsg1: "Questo numero è stato registrato per diversi pazienti.",
      choosePatMsg2: "Clicca sul nome del paziente per proseguire.",
      sendAnother: "Invia un altro file",
      nessunFile: "Nessun file",
      inviato: "inviato",
      ricevuto: "ricevuto",
      sendMailError:
        "Ci spiace, si è verificato un errore durante l'invio della mail, prego riprovare",
      mailFieldsErr: "Oggetto e messaggio della mail non possono essere vuoti.",
      fileDimErrTit: "File superano dimensione massima",
      fileDimErrMsg: "L'insieme dei file non può superare 25MB",
      phoneErrTit: "Prego inserire un numero di telefono valido",
      phoneErrMsg: "Il formato inserito non è valido",
      clickOn: "Clicca su",
      toSeeFile: "per vedere il file selezionato",
      toDownloadFile: "per scaricare il file selezionato",
      toReply: "per rispondere alla comunicazione e inviare ulteriori file",
      sendLabel: "Invia",
      downloadLabel: "Scarica",
      viewLabel: "Visualizza"
    }
  }
};

export { messages };



// WEBPACK FOOTER //
// ./src/utils/messages.js